import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    TextField,
    Box,
    Typography,
    CircularProgress
} from '@mui/material';
import { RecycleBinDeleteSVG } from '../../../components';
import { makeandcheckerService } from '../../../services';
import { dateFns } from '../../../helpers';
import actionTypes from '../../../constants/makeandchecker/actionsTypeId';
import clientStatuses from '../../../constants/users/statuses';
import '../../../styles/sass/clients/clientDialogs.scss';
import { useTranslation } from 'react-i18next';
import { palette } from '../../../styles/theme';

export default function ClientsDeleteDialog ({ client, show, onHide, onDelete, setAlert, setOpenAlert }) {
    // State
    const { t } = useTranslation();
    // Delete reason state
    const [reason, setReason] = useState('');
    // Loading state
    const [isLoading, setIsLoading] = useState(false);
    // Reason alert state
    const [reasonAlert, setReasonAlert] = useState({
        reason: '',
        description: ''
    });

    // Functions

    const deleteClient = () => {
        if (!_.trim(reason || '')) {
            setReasonAlert({
                reason: 'empty',
                description: t('clients.table.menu.unsubscribe.modal.warningEmpty')
            });
            return;
        }
        if (reason.length > 100) {
            setReasonAlert({
                reason: 'excess',
                description: t('clients.table.menu.unsubscribe.modal.warningExcess')
            });
            return;
        }

        setIsLoading(true);

        const data = {
            idType: actionTypes.updateUserStatus,
            metadata: {
                path: {
                    id: client.id
                },
                body: {
                    idStatus: clientStatuses.inactive.id,
                    reason
                },
                client: {
                    formattedName: client.formattedName.toLowerCase()
                }
            }
        };

        makeandcheckerService
            .createAction(data)
            .then(() => {
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'success',
                    description: (
                        <Box display='flex' flexDirection='row' alignItems='baseline'>
                            <Typography variant='subtitle2'>{t('clients.table.menu.unsubscribe.modal.success')}</Typography>
                            <Box margin= '0px 2px 0px 2px'/>
                            <Typography variant='subtitle1'>{client.formattedName}</Typography>
                        </Box>
                    ),
                    className: 'clientsMC_Alert--success'
                }));
                setOpenAlert(true);
            })
            .catch(e => {
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'error',
                    title: 'Algo no salió como esperamos',
                    description: 'Lo sentimos, en este momento no fue posible completar la operación.',
                    className: 'clientsMC_Alert--error'
                }));
                setOpenAlert(true);
                console.error('Error on create adjustment', e);
            })
            .finally(() => {
                setIsLoading(false);
                onDelete();
                onHide();
            });
    };

    // Events

    // if !id we should close modal
    useEffect(() => {
        if (!client) {
            onHide();
        }
        // eslint-disable-next-line
    }, [client]);

    // Main Component

    return (
        <Dialog
            open={show}
            onClose={onHide}
            PaperProps={{ style: { padding: '32px', borderRadius: '16px', backgroundColor: palette.beige[50] } }}
        >
            <Box
                display='flex'
                justifyContent='center'
                flexDirection='column'
                gap={'40px'}
                width={'396px'} >
                <Box
                    display='flex'
                    flexDirection='column'
                    textAlign='center'
                    justifyContent='center'>
                    <Box><RecycleBinDeleteSVG /></Box>
                    <span className='delete_text-title'>¿{t('clients.table.menu.unsubscribe.modal.title')} <br /><b>{`${client.formattedName}`}?</b></span>
                    <span className='delete_text--date'>{`${t('clients.table.menu.unsubscribe.modal.date')}: ${dateFns.format(new Date(), 'dd/MM/yyyy')}`}</span>
                </Box>
                <Box>
                    <TextField
                        placeholder={t('clients.table.menu.unsubscribe.modal.placeholder')}
                        color='secondary'
                        label={t('clients.table.menu.unsubscribe.modal.reason')}
                        fullWidth
                        autoComplete="off"
                        variant='outlined'
                        multiline
                        InputLabelProps={{ shrink: true }}
                        onChange={e => setReason(e.target.value)}
                        value={reason}
                    />
                    {reasonAlert.reason && !(reason.length > 1 && reason.length < 100) ? (<Box className='errorbox' style={{ marginBottom: '0', marginTop: '6px' }}><Typography className='clientsDeleteDialog_reasonAlert--message' variant= 'body2'>
                        {reasonAlert.description}
                    </Typography>
                    </Box>) : null
                    }
                </Box>
                <Box
                    display='flex'
                    justifyContent='right'
                    gap='32px'>
                    <Button className='delete_button--cancel' onClick={onHide} disabled={isLoading}>
                        {t('buttons.cancel')}
                    </Button>
                    <Button className="delete_button--submit" appearance="primary" onClick={deleteClient} disabled={isLoading}>
                        {(isLoading ? <CircularProgress size={24} style={{ color: 'white' }} />
                            : t('buttons.confirm'))}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
}
